import axios from "axios";
import {
  Box,
  Button,
  HtmlEditor,
  List,
  TabPanel,
  Toolbar as Toolbar2,
} from "devextreme-react";
import AuthFileUploader from "../common/AuthFileUploader";
import { Item as BoxItem } from "devextreme-react/box";
import { Toolbar } from "devextreme-react/html-editor";
import { Item as TabPanelItem } from "devextreme-react/tab-panel";
import { Item } from "devextreme-react/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { pdfjs } from "react-pdf";
import { notifyMsg } from "../common/notify";
import TrainingReportFileViewer from "./TrainingReportFileViewer";
import ArrayStore from "devextreme/data/array_store";
import { useSelector } from "react-redux";

export default function TrainingReport(props) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const {
    trRecData,
    // setSetFileListDataSource,
    // fileListDataSource,
    // reportTabPanelRef,
    // reportDescriptionRef,
    // setReportDescr,
    // reportDescr,
    trRecGridRef,
    reportPopupVisible,
    setReportPopupVisible,
    userInfo,
    currentEmployeeNo,
  } = props;

  const [fileListDataSource, setFileListDataSource] = useState(null);
  const [reportDescr, setReportDescr] = useState(null);

  const [selectedItem, setSelectedItem] = useState(null);

  const reportDescriptionRef = useRef(null);
  const reportTabPanelRef = useRef(null);

  useEffect(() => {
    // if (!reportPopupVisible) {

    setFileListDataSource(null);

    if (reportDescriptionRef.current) {
      reportDescriptionRef.current.instance.reset();
    }

    if (reportTabPanelRef.current) {
      let items = reportTabPanelRef.current.instance.option("items");

      items.splice(1);

      reportTabPanelRef.current.instance.repaint();
    }
    // }
  }, []);

  useEffect(() => {
    if (reportDescriptionRef.current) {
      reportDescriptionRef.current.instance.option("value", reportDescr);
    }
  }, [reportDescr]);

  useEffect(async () => {
    if (trRecData) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/rpt/${trRecData.tpId}/${trRecData.SEQ}`
      );

      // setReportDescr(result.data.rpt);
      setSetFileListDataSource(trRecData, result.data.rpt);
    }
  }, [trRecData]);

  // useEffect(() => {
  //   // if (!reportPopupVisible) {
  //   if (reportPopupVisible) {
  //     console.debug("[reportPopupVisible]");

  //     // setFileListDataSource(null);

  //     // if (reportDescriptionRef.current) {
  //     //   reportDescriptionRef.current.instance.reset();
  //     // }

  //     if (reportTabPanelRef.current) {
  //       let items = reportTabPanelRef.current.instance.option("items");

  //       items.splice(1);

  //       reportTabPanelRef.current.instance.repaint();

  //       console.debug("reportDescr", reportDescr);

  //       if (reportDescriptionRef.current) {
  //         reportDescriptionRef.current.instance.option("value", reportDescr);
  //       }
  //     }
  //   }
  // }, [reportPopupVisible]);

  const setSetFileListDataSource = async (data, rpt) => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/rpt/fileList/${data.tpId}/${data.SEQ}`
    );

    setFileListDataSource(
      new ArrayStore({
        key: "id",
        data: result.data,
      })
    );

    if (result.data) {
      if (reportTabPanelRef.current) {
        let items = reportTabPanelRef.current.instance.option("items");

        items.splice(1);

        reportTabPanelRef.current.instance.repaint();
      }

      if (rpt) {
        setReportDescr(rpt);
      }
    }
  };

  const onUploaded = (e) => {
    setSetFileListDataSource(
      trRecData,
      reportDescriptionRef.current.instance.option("value")
    );
  };

  const onItemDeleted = async (e) => {
    axios
      .delete(
        `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/rpt/file/${e.itemData.id}`
      )
      .then(() => {
        setSetFileListDataSource(e.itemData);
      });
  };

  const onFileListItemSelectionChanged = (e) => {
    if (e.addedItems[0]) {
      let items = reportTabPanelRef.current.instance.option("items");
      const item = {
        title: e.addedItems[0].text,
        // template: `<div>Test</div>`,
        // template: itemTemplate,
        // template: itemTemplate,
        // render: itemRender,
        data: e.addedItems[0],
      };

      const index = items.findIndex((element) => element.title == item.title);

      if (index == -1) {
        items.push(item);
        reportTabPanelRef.current.instance.repaint();

        setSelectedItem(item);
        reportDescriptionRef.current.instance.option("value", reportDescr);
        // setReportDescr(reportDescriptionRef.current.instance.option("value"));
      } else {
        setSelectedItem(items[index]);
      }
    }

    // const value = reportDescriptionRef.current.instance.option("value");
    // const value = JSON.parse(
    //   JSON.stringify(reportDescriptionRef.current.instance.option("value"))
    // );

    // reportTabPanelRef.current.instance.option("items", items);

    // setReportDescr(value);
  };

  const itemTitleRender = (data) => {
    return (
      <div>
        <span>{data.title}</span>
        {data.title != "Report" && (
          <i
            className="dx-icon dx-icon-close"
            onClick={() => {
              closeButtonHandler(data);
            }}
          />
        )}
      </div>
    );
  };

  const closeButtonHandler = (item) => {
    let items = reportTabPanelRef.current.instance.option("items");
    const index = items.indexOf(item);

    items.splice(index, 1);

    reportTabPanelRef.current.instance.repaint();

    // setSelectedItem(items[0]);
    reportDescriptionRef.current.instance.option("value", reportDescr);
  };

  const itemRender = (itemData, itemIndex, itemElement) => {
    return <TrainingReportFileViewer itemData={itemData} />;
  };

  const onClickSave = async (e) => {
    const value = reportDescriptionRef.current.instance.option("value");

    if (value) {
      axios
        .put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/rpt/${trRecData.tpId}/${trRecData.SEQ}`,
          {
            rpt: value,
          }
        )
        .then(() => {
          trRecGridRef.current.instance.getDataSource().reload();

          setReportPopupVisible(false);
        });
    } else {
      notifyMsg("Report를 작성해주세요,", "warning");
    }
  };

  const onSelectionChanged = React.useCallback(
    (args) => {
      setSelectedItem(args.addedItems[0]);
    },
    [setSelectedItem]
  );

  return (
    <Box direction="row" width={"100%"} height={700}>
      <BoxItem ratio={0} baseSize={400}>
        {trRecData && (
          <div>
            <Toolbar2>
              <Item location="before">
                <span
                  style={{
                    fontWeight: 500,
                    color: "#009688",
                    marginLeft: "10px",
                  }}
                >
                  RELATED DOCUMENT LIST
                </span>
              </Item>
            </Toolbar2>
            {currentEmployeeNo == userInfo.employeeNo && (
              <div>
                <AuthFileUploader
                  id="rapoertFileUploader"
                  uploadMode="instantly"
                  uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/lrnMgmt/trRec/rpt/${trRecData.tpId}/${trRecData.SEQ}`}
                  accept="*"
                  showFileList={false}
                  multiple={true}
                  allowedFileExtensions={[
                    ".jpg",
                    ".jpeg",
                    ".gif",
                    ".png",
                    ".pdf",
                  ]}
                  onUploaded={onUploaded}
                />
                <span className="note">
                  {"* Allowed file extensions: "}
                  <span>.jpg, .jpeg, .gif, .png, .pdf</span>
                </span>
              </div>
            )}
          </div>
        )}
        <List
          dataSource={fileListDataSource}
          keyExpr={"id"}
          // valueExpr="filePath"
          height={"auto"}
          allowItemDeleting={
            userInfo.employeeNo == currentEmployeeNo ? true : false
          }
          itemDeleteMode="toggle"
          selectionMode="single"
          noDataText=""
          onItemDeleted={onItemDeleted}
          onSelectionChanged={onFileListItemSelectionChanged}
        />
      </BoxItem>
      <BoxItem ratio={1} baseSize={"80%"}>
        <TabPanel
          id="reportTabPanel"
          ref={reportTabPanelRef}
          deferRendering={false}
          height={"100%"}
          showNavButtons={true}
          // itemTemplate={itemTemplate}
          // itemTitleRender={itemTitleRender}
          itemRender={itemRender}
          repaintChangesOnly={true}
          selectedItem={selectedItem}
          onSelectionChanged={onSelectionChanged}
        >
          <TabPanelItem title={"Report"}>
            {currentEmployeeNo == userInfo.employeeNo && (
              <div style={{ height: "100%" }}>
                <HtmlEditor
                  id="reportDescription"
                  ref={reportDescriptionRef}
                  // height={300}
                  height={"95%"}
                  valueType={"html"}
                  // defaultValue={descr}
                  //   value={descr}
                  //   onValueChanged={onValueChanged}
                >
                  <Toolbar multiline={true}>
                    <Item name="undo" />
                    <Item name="redo" />
                    <Item name="separator" />
                    <Item
                      name="size"
                      acceptedValues={[
                        "8pt",
                        "10pt",
                        "12pt",
                        "14pt",
                        "18pt",
                        "24pt",
                        "36pt",
                      ]}
                    />
                    <Item
                      name="font"
                      acceptedValues={[
                        "Arial",
                        "Courier New",
                        "Georgia",
                        "Impact",
                        "Lucida Console",
                        "Tahoma",
                        "Times New Roman",
                        "Verdana",
                      ]}
                    />
                    <Item name="separator" />
                    <Item name="bold" />
                    <Item name="italic" />
                    <Item name="strike" />
                    <Item name="underline" />
                    <Item name="separator" />
                    <Item name="alignLeft" />
                    <Item name="alignCenter" />
                    <Item name="alignRight" />
                    <Item name="alignJustify" />
                    <Item name="separator" />
                    <Item name="orderedList" />
                    <Item name="bulletList" />
                    <Item name="separator" />
                    <Item
                      name="header"
                      acceptedValues={[false, 1, 2, 3, 4, 5]}
                    />
                    <Item name="separator" />
                    <Item name="color" />
                    <Item name="background" />
                    <Item name="separator" />
                    <Item name="link" />
                    <Item name="separator" />
                    <Item name="clear" />
                    <Item name="codeBlock" />
                    <Item name="blockquote" />
                    <Item name="separator" />
                    <Item name="insertTable" />
                    <Item name="deleteTable" />
                    <Item name="insertRowAbove" />
                    <Item name="insertRowBelow" />
                    <Item name="deleteRow" />
                    <Item name="insertColumnLeft" />
                    <Item name="insertColumnRight" />
                    <Item name="deleteColumn" />
                  </Toolbar>
                </HtmlEditor>
                <Button
                  text={"SAVE"}
                  type={"normal"}
                  stylingMode="text"
                  onClick={onClickSave}
                />
              </div>
            )}
            {currentEmployeeNo != userInfo.employeeNo && (
              <div
                dangerouslySetInnerHTML={{
                  __html: reportDescr,
                }}
              ></div>
            )}
          </TabPanelItem>
        </TabPanel>
      </BoxItem>
    </Box>
  );
}
